import "react-datepicker/dist/react-datepicker.css";

import _ from "lodash";
import React, {useEffect, useState} from "react";
import {Button, Col, Form, Modal, Row, Table} from "react-bootstrap";
import {FmlxIcon} from "fmlx-common-ui";
import * as MdIcon from "react-icons/md";
import {Get, Post} from "../../lib/Request";
import {getCookie} from "../../lib/cookieHelper";
import {API_ACTION, API_COMPANY} from "../../const/Api";
import LoadingComponent from "../../components/LoadingComponent";
import {ALERT_VARIANT, COOKIE_AUTHTOKEN} from "../../const/dataEnum";
import {useDispatch} from "react-redux";
import {setAlert} from "../../stores/actions/alertModalStateAction";

const ManageCompany = () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [type, setType] = useState("add");
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [loadingModify, setLoadingModify] = useState(false);
  const [flag, setFlag] = useState(false);

  const [companyId, setCompanyId] = useState();
  const [newCompany, setNewCompany] = useState({
    companyName: "",
    address: "",
  });

  useEffect(() => {
    mountApis();
  }, []);

  const mountApis = async () => {
    setLoading(true);
    let result = await Get(API_COMPANY);
    setLoading(false);
    setCompanies(result.data);
  };
  const viewEmployee = (prop) => {
    if (prop === "Create") {
      let coyValue = newCompany;
      setCompanyId(0);
      coyValue.companyName = "";
      coyValue.address = "";
      setNewCompany(coyValue);
    }
    setType(prop);
    setShow(true);
  };

  const handleNewCompanyInput = (type, value) => {
    const coyValue = newCompany;

    // eslint-disable-next-line default-case
    switch (type) {
      case "companyName":
        coyValue.companyName = value;
        break;
      case "address":
        coyValue.address = value;
        break;
    }
    setNewCompany(coyValue);
    setFlag(!flag);
  };

  const handleRegisterCompany = async (e) => {
    e.preventDefault();
    let newObj;

    if (type === "Update") newObj = {id: parseInt(companyId), ...newCompany};
    else newObj = _.cloneDeep(newCompany);

    const token = getCookie(COOKIE_AUTHTOKEN);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authentication: `Bearer ${token}`,
      },
      body: newObj,
    };

    let responseCheck;

    if (type === "Update") {
      responseCheck = await Post(API_COMPANY + API_ACTION.UPDATE, headers.body, headers.headers);
      if (responseCheck.message === "Success") {
        let filterCompanies = companies.map((coy) =>
          coy.id === companyId
            ? {
              id: coy.id,
              companyName: newCompany.companyName,
              address: newCompany.address,
            }
            : _.cloneDeep(coy)
        );
        setCompanies(filterCompanies);
      }
    } else {
      responseCheck = await Post(API_COMPANY + API_ACTION.CREATE, headers.body, headers.headers);
      if (responseCheck.message === "Success") {
        let filterCompanies = companies;
        filterCompanies.push({
          id: companies.length,
          companyName: newCompany.companyName,
          address: newCompany.address,
        });
        setCompanies(filterCompanies);
      }
    }
    setFlag(!flag);
    setShow(false);
    if (responseCheck.responseCode === 0) {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.SUCCESS,
          message: responseCheck.message,
        })
      );
      await mountApis();
    } else {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.ERROR,
          message: responseCheck.message,
        })
      );
    }
  };

  const handleDelete = async (id, coy) => {
    const token = getCookie(COOKIE_AUTHTOKEN);

    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authentication: `Bearer ${token}`,
      },
      body: {id: parseInt(id), ...coy},
    };

    const response = await Post(API_COMPANY + API_ACTION.DELETE, headers.body, headers.headers);

    if (response.responseCode === 0) {
      const remainingCompanies = companies.filter((coy) => coy.id !== id);
      setCompanies(remainingCompanies);
      setFlag(!flag);
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.SUCCESS,
          message: response.message,
        })
      );
    } else {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.ERROR,
          message: response.message,
        })
      );
    }
  };

  return (
    <div className="container">
      <div>
        <Button onClick={() => viewEmployee("Create")}>Register Company</Button>
        <Table>
          <thead>
          <tr>
            <th width="50">No</th>
            <th width="450">Company Name</th>
            <th width="400">Address</th>
          </tr>
          </thead>
          <tbody>
          {loading ? (
            <tr>
              <td className="text-center" colSpan={7}>
                {<LoadingComponent/>}
              </td>
            </tr>
          ) : companies.length === 0 ? (
            <tr>
              <td className="text-center" colSpan={7}>
                No Data
              </td>
            </tr>
          ) : (
            companies.map((element, index) => {
              return (
                <tr key={index}>
                  <td className="text-center">{index + 1}</td>
                  <td>{element.companyName}</td>
                  <td>{element.address}</td>
                  <td>
                    <Button
                      onClick={() => {
                        viewEmployee("Update");
                        setCompanyId(element.id);
                        let coyValue = newCompany;
                        coyValue.companyName = element.companyName;
                        coyValue.address = element.address;
                        setNewCompany(coyValue);
                      }}
                    >
                      <FmlxIcon name="EditorOutline"/>
                    </Button>
                  </td>
                  <td>
                    <Button
                      className="btn btn-danger"
                      onClick={() => {
                        let coyValue = newCompany;
                        coyValue.companyName = element.companyName;
                        coyValue.address = element.address;
                        handleDelete(element.id, coyValue);
                      }}
                    >
                      <MdIcon.MdDelete/>
                    </Button>
                  </td>
                </tr>
              );
            })
          )}
          </tbody>
        </Table>
      </div>
      <Modal show={show} onHide={() => setShow(false)} centered size="lg">
        <Form>
          <Modal.Header closeButton>
            <Modal.Title>{type === "Create" ? "Register" : "View"} Company</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <Form.Group size="lg" controlId="companyName" className="mb-2">
                  <Form.Label>Company Name</Form.Label>
                  <Form.Control
                    autoFocus
                    type="text"
                    value={newCompany?.companyName}
                    onChange={(e) => handleNewCompanyInput(e.target.id, e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group size="lg" controlId="address" className="mb-2">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    autoFocus
                    type="text"
                    value={newCompany?.address}
                    onChange={(e) => handleNewCompanyInput(e.target.id, e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              size="md"
              type="submit"
              style={{width: "150px"}}
              disabled={loadingModify}
              onClick={(e) => handleRegisterCompany(e)}
            >
              {loadingModify ? (
                <div>
                  <span
                    style={{marginLeft: "0px"}}
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </div>
              ) : (
                "Save Changes"
              )}
            </Button>
            <Button variant="secondary" onClick={() => setShow(false)} disabled={loadingModify}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default ManageCompany;
